import React from 'react';
import { useTenantsApp } from '../../Context/TenantsApp/TenantsAppContext';
import { SET_ERROR, TOGGLE_SYNC_ALL_TENANTS_DIALOG } from './TenantsAppEvents';
import { useTranslation } from 'react-i18next';

const SyncAllTenants = () => {

    const { state, dispatch } = useTenantsApp();

    const { t } = useTranslation([
        "tenant/tenant",
    ], {
        useSuspense: false
    })

    const handleSyncAllTenants = async () => {
        dispatch({ type: TOGGLE_SYNC_ALL_TENANTS_DIALOG });
    }

    const isAnyTenantSyncing = state.tenants.some(tenant => tenant.syncStatus === "In Progress" || tenant.syncStatus === "Queued");
    const isAllTenantSyncing = state.tenants.every(tenant => tenant.syncStatus === "In Progress" || tenant.syncStatus === "Queued");
    const isAppValid = state.project.isActive && !state.project.hasSchemaChanges

    return (
        <div className={`d-flex align-items-center justify-content-between`}>
            <div class="d-flex align-items-center">
                <div class=" header d-flex">
                    <span class="d-block p-2 pe-2 ps-4 d-flex align-items-center">
                        <div>
                            <span class="page-header">
                                {t("tenants")}
                                {!isAppValid &&
                                    <span className='text-danger ms-5 text-end'>
                                        <i className="fas fa-exclamation-triangle me-2"></i>
                                        <small>
                                            {t("schema_update")}
                                            <span className="text-muted">
                                                -
                                                {t("schema_update_message")}
                                            </span>
                                        </small>
                                    </span>
                                }
                                {state.errorMessage &&
                                    <span className='text-danger ms-5 text-end'>
                                        <i className="fas fa-exclamation-triangle me-2"></i>
                                        <small>
                                            {state.errorMessage}
                                        </small>
                                        <i className="fas fa-times-circle ms-2" onClick={() => dispatch({ type: SET_ERROR, payload: null })}></i>
                                    </span>
                                }
                            </span>
                        </div>
                    </span>
                </div>
            </div>
            {state.selectedTenantIds.length > 0 &&
                <button
                    disabled={isAllTenantSyncing || isAnyTenantSyncing || state.selectedTenantIds.length === 0 || !isAppValid}
                    onClick={handleSyncAllTenants}
                    className={`float-end btn btn-sm ${(isAllTenantSyncing || isAnyTenantSyncing) ? 'btn-success' : 'btn-primary'}`}>
                    {(isAllTenantSyncing || isAnyTenantSyncing) ?

                        <i className="fas fa-sync fa-spin me-2"></i>
                        :
                        <i className="fas fa-sync me-2"></i>
                    }
                    {
                        isAllTenantSyncing || isAnyTenantSyncing ?
                            t("syncing_tenants")
                            :
                            t("sync_tenants")
                    }
                </button>
            }
        </div>
    )
}

export default SyncAllTenants;